import { UserSquare, NoteText, ShieldTick, SearchNormal1, Chart2 } from 'iconsax-reactjs';

import { NavItemType } from 'types/menu';

const icons = {
  terceros: UserSquare,
  cuestionarios: NoteText,
  evaluaciones: ShieldTick,
  screenings: SearchNormal1,
  reportes: Chart2
};

const terceros: NavItemType = {
  id: 'group-administracion-terceros',
  title: 'menu.group.administracion-terceros',
  type: 'group',
  children: [
    {
      id: 'terceros',
      title: 'menu.item.terceros',
      type: 'item',
      url: '/terceros',
      icon: icons.terceros,
      breadcrumbs: false,
      permissions: ['terceros.ver']
    },
    {
      id: 'cuestionarios',
      title: 'menu.item.cuestionarios',
      type: 'item',
      url: '/cuestionarios',
      icon: icons.cuestionarios,
      breadcrumbs: false,
      permissions: ['cuestionarios.ver']
    },
    {
      id: 'evaluaciones',
      title: 'menu.item.evaluaciones',
      type: 'item',
      url: '/evaluaciones',
      icon: icons.evaluaciones,
      breadcrumbs: false,
      permissions: ['evaluaciones.ver']
    },
    {
      id: 'screenings',
      title: 'menu.item.screenings',
      type: 'item',
      url: '/screenings',
      icon: icons.screenings,
      breadcrumbs: false,
      permissions: ['screening.ver_resultados']
    },
    {
      id: 'analisis-reportes',
      title: 'menu.item.analisis-reportes',
      type: 'item',
      url: '/analisis-reportes',
      icon: icons.reportes,
      breadcrumbs: false,
      permissions: ['descarga.ver_resumenes', 'descarga.exportar_reportes']
    }
  ]
};

export default terceros;
